module.exports = __webpack_public_path__ + "static/media/hero_desktop.4e5ab67e.webp";